<template>
  <div class="backup">
    <div class="backup-view" v-show="gotop" @click="toTop">
      <span class="el-icon-arrow-up"></span>
    </div>
  </div>
</template>

<script>
export default {
  name: "index",
  data() {
    return {
      gotop: false
    };
  },
  mounted() {
    // 此处true需要加上，不加滚动事件可能绑定不成功
    window.addEventListener("scroll", this.handleScroll, true);
  },
  methods: {
    // 滚动到指定位置显示按钮
    handleScroll() {
      let scrolltop = document.documentElement.scrollTop || document.body.scrollTop;
      scrolltop > 30 ? (this.gotop = true) : (this.gotop = false);
    },

    // 滚动回到顶部
    toTop() {
      let top = document.documentElement.scrollTop || document.body.scrollTop;
      // 实现滚动效果
      const timeTop = setInterval(() => {
        document.body.scrollTop = document.documentElement.scrollTop = top -= 50;
        if (top <= 0) {
          clearInterval(timeTop);
        }
      });
    }
  }
}
</script>

<style scoped lang="less">
.backup {
  position: fixed;
  bottom: 55px;
  right: 37px;
  border-radius: 7px;
  overflow: hidden;
  z-index: 999;

  &:hover {
    cursor: pointer;
  }

  .backup-view {
    width: 46px;
    height: 46px;
    background-color: #3E88F1;

    font-size: 30px;
    color: white;
    text-align: center;
    line-height: 43px;
  }
}
</style>